export default __webpack_public_path__ + "static/StreetTreeOrdinanceAndManagementPlan-42a054eea3f28da6bc5c2412ec136b10.jpg";